module.exports = __webpack_public_path__ + "img/f5.1ce0032b.png";